import React, { Component } from 'react';
import MonthPicker from 'react-month-picker';
import 'react-month-picker/css/month-picker.css';

class MultiMonthPicker extends Component {
  constructor(props) {
    super(props);
    this.monthPickerRef = React.createRef();
    this.state = {
      selectedMonths: []
    };
  }

  handleClickMonthBox = (e) => {
    e.preventDefault();
    this.monthPickerRef.current.show();
  };

  handleMonthChange = (year, month) => {
    const newMonth = { year, month };

    this.setState(prevState => {
      // Check if month is already selected
      const exists = prevState.selectedMonths.some(
        m => m.year === year && m.month === month
      );

      if (exists) {
        // Remove if exists
        return {
          selectedMonths: prevState.selectedMonths.filter(
            m => !(m.year === year && m.month === month)
          )
        };
      } else {
        // Add if not exists
        return {
          selectedMonths: [...prevState.selectedMonths, newMonth]
        };
      }
    });
  };

  makeText = (m) => {
    const months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun',
                   'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
    if (m && m.year && m.month) {
      return `${months[m.month-1]}. ${m.year}`;
    }
    return '?';
  };

  render() {
    const { selectedMonths } = this.state;
    const pickerLang = {
      months: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun',
              'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec']
    };

    return (
      <div style={{ padding: '20px', maxWidth: '500px', margin: '0 auto' }}>
        <div style={{ marginBottom: '20px' }}>
          <h3>Select months:</h3>
          <div
            onClick={this.handleClickMonthBox}
            style={{
              padding: '10px',
              border: '1px solid #ddd',
              borderRadius: '4px',
              cursor: 'pointer',
              minHeight: '20px',
              background: '#f9f9f9'
            }}
          >
            {selectedMonths.length > 0
              ? selectedMonths.map(this.makeText).join(' | ')
              : 'Click to select months...'}
          </div>
        </div>

        <MonthPicker
          ref={this.monthPickerRef}
          lang={pickerLang.months}
          years={{
            min: { year: 2016, month: 1 },
            max: {
              year: new Date().getFullYear(),
              month: new Date().getMonth() + 1
            }
          }}
          value={selectedMonths}
          onChange={this.handleMonthChange}
          theme="light"
        />
      </div>
    );
  }
}

export default MultiMonthPicker;